import { Box, BoxProps } from "@chakra-ui/react";
import { FC } from "react";

const Divider: FC<BoxProps> = props => <Box {...props} h="1px" w="100%" bg="#e2e8f0" />;

export default Divider;
